import { type Meta } from '../types/docs';
import { WORKSPACE_AGENT_ANALYTICS_CATEGORY_META_PARAM } from './workspaceAgentAnalytics';

export const WORKSPACE_AGENT_NEXT_ACTION_PILL_IDS = ['make_variants', 'rename', 'tag'] as const;

export type WorkspaceAgentNextActionPillId = (typeof WORKSPACE_AGENT_NEXT_ACTION_PILL_IDS)[number];

const META: Meta = {
  description: "The user clicks a What's next pill (Make variants, Rename, or Tag) on the guided variant flow",
  name: 'agent_next_action_pill_clicked',
  params: [
    WORKSPACE_AGENT_ANALYTICS_CATEGORY_META_PARAM,
    {
      description: 'Which pill was clicked',
      name: 'pill_id',
      required: true,
      type: 'enum',
      values: [...WORKSPACE_AGENT_NEXT_ACTION_PILL_IDS],
    },
  ],
};

export default META;
